import type { ReactNode } from 'react';

import { QueryProvider } from '@/app/providers/query-provider';
import { AuthProvider } from '@/modules/auth/hooks/auth-provider';

/**
 * Ponto único de composição dos providers globais do painel.
 *
 * `AuthProvider` fica dentro do `QueryProvider` porque a reidratação da sessão
 * pode passar a usar TanStack Query no futuro; o contrário criaria a dependência
 * na direção errada.
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <QueryProvider>
      <AuthProvider>{children}</AuthProvider>
    </QueryProvider>
  );
}
